export default __webpack_public_path__ + "static/media/key-card.c289f2f1.svg";